// extracted by mini-css-extract-plugin
export var adaButton = "Footer-module--adaButton--7aa71";
export var bottom = "Footer-module--bottom--51364";
export var bottomContainer = "Footer-module--bottom-container--caf54";
export var bottomLinksSection = "Footer-module--bottom-links-section--cd9db";
export var bottomList = "Footer-module--bottom-list--41f58";
export var contactList = "Footer-module--contact-list--ba0a3";
export var container = "Footer-module--container--ef872";
export var footer = "Footer-module--footer--65ad4";
export var footerLink = "Footer-module--footer-link--0c8ea";
export var footerList = "Footer-module--footer-list--3515f";
export var levelAccessIcon = "Footer-module--level-access-icon--0233a";
export var linkSection = "Footer-module--link-section--5252d";
export var logo = "Footer-module--logo--0c93a";
export var noTopMargin = "Footer-module--noTopMargin--03c6c";
export var section = "Footer-module--section--5d7dd";
export var separator = "Footer-module--separator--23762";
export var storeButton = "Footer-module--store-button--ce5ad";
export var subtitle = "Footer-module--subtitle--5fda8";
export var title = "Footer-module--title--1ea06";
export var underlinedLink = "Footer-module--underlined-link--0918e";